export const PRIVACY_POLICY_ACTION_START = 'PRIVACY_POLICY_ACTION_START';
export const PRIVACY_POLICY_ACTION_ERROR = 'PRIVACY_POLICY_ACTION_ERROR';
export const GET_ALL_PRIVACY_POLICIES = 'GET_ALL_PRIVACY_POLICIES';
export const GET_PRIVACY_POLICY = 'GET_PRIVACY_POLICY';
export const CREATE_PRIVACY_POLICY = 'CREATE_PRIVACY_POLICY';
export const EXPIRE_PRIVACY_POLICY = 'EXPIRE_PRIVACY_POLICY';
export const ACTIVATE_PRIVACY_POLICY = 'ACTIVATE_PRIVACY_POLICY';

export const privacyPolicyActionStart = () => ({ type: PRIVACY_POLICY_ACTION_START });
export const privacyPolicyActionError = (error: any) => ({ type: PRIVACY_POLICY_ACTION_ERROR, payload: error });
export const getAllPrivacyPoliciesAction = (policies: any[]) => ({ type: GET_ALL_PRIVACY_POLICIES, payload: policies });
export const getPrivacyPolicyAction = (policy: any) => ({ type: GET_PRIVACY_POLICY, payload: policy });
export const createPrivacyPolicyAction = (policy: any) => ({ type: CREATE_PRIVACY_POLICY, payload: policy });
export const expirePrivacyPolicyAction = (policyId: string) => ({ type: EXPIRE_PRIVACY_POLICY, payload: policyId });
export const activatePrivacyPolicyAction = (policyId: string) => ({ type: ACTIVATE_PRIVACY_POLICY, payload: policyId });

